// extracted by css-extract-rspack-plugin
export default {"itemWrapper":"_6ee894bc","imageWrapper":"_ea3b856e","image":"_7809673d"};